import invariant from 'invariant';
import queryString from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default (params) => {
    let { baseUrl, brandId, clientId, country, requestOptions = {}, options = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of getStaticDeliveryInfo()');
    invariant(brandId, 'brandId is a required param of getStaticDeliveryInfo()');
    invariant(clientId, 'clientId is a required param of getStaticDeliveryInfo()');
    invariant(country, 'country is a required param of getStaticDeliveryInfo()');

    const query = queryString.stringify(options);
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/shipping_info${query.length ? `?${query}` : ''}`;

    return labelRequest(authenticatedRequest(new Request(url, requestOptions), null, clientId), 'getStaticDeliveryInfo');
};
